import { render, staticRenderFns } from "./IntlBreadcrumb.vue?vue&type=template&id=d501c630&scoped=true"
import script from "./IntlBreadcrumb.vue?vue&type=script&lang=js"
export * from "./IntlBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./IntlBreadcrumb.vue?vue&type=style&index=0&id=d501c630&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d501c630",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d501c630')) {
      api.createRecord('d501c630', component.options)
    } else {
      api.reload('d501c630', component.options)
    }
    module.hot.accept("./IntlBreadcrumb.vue?vue&type=template&id=d501c630&scoped=true", function () {
      api.rerender('d501c630', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/IntlBreadcrumb.vue"
export default component.exports